// src/components/auth/MarcaEntrada.jsx
//
// A metade de cima da tela de login: halo pulsando, marca e a assinatura.
// Fonte: Entrada.dc.html (tela `login`).
//
// O `Entrada.dc.html` desenha um símbolo inline (o "boneco" azul). Aqui vale
// a REGRA DA LACUNA 17: o wordmark do handoff escreve "VITA", que é o agente
// de IA, não o app — então o símbolo é o logo LesVita que já existe em
// `Assets/images/logo`, tingido de azul, e o wordmark é montado em texto,
// com LES em peso médio e VITA em extrabold, como o desenho pede.

import React from "react";
import Style from "../../styles/components/auth/Entrada.module.scss";
import marca from "../../Assets/images/logo/escuroGrad.svg";

export default function MarcaEntrada() {
  return (
    <div className={Style.marca}>
      <span className={Style.halo} aria-hidden="true" />
      <img className={Style.logo} src={marca} alt="" aria-hidden="true" />
      <div className={Style.wordmark}>
        <span className={Style.wordLes}>LES</span>
        <span className={Style.wordVita}>VITA</span>
      </div>
      <span className={Style.assinatura}>Sua evolução, todos os dias</span>
    </div>
  );
}
